import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-smtp',
  templateUrl: './email-smtp.component.html',
  styleUrls: ['./email-smtp.component.scss']
})
export class EmailSmtpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
